import { Directive, Input, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appElememt]'
})
export class ElememtDirective {

   @Input() appElememt: any;

  constructor(public viewContainerRef: ViewContainerRef) { }

}
